// Anonym sporing av sidebesøk for admin-statistikk.
// Lagrer ingen personalia – kun en tilfeldig UUID i localStorage som "session_id".
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = 'vsk_visitor_id';

// Sider vi ikke skal telle (admin-flater)
const EXCLUDED_PREFIXES = ['/admin', '/tennis/admin'];

function isExcluded(path) {
  return EXCLUDED_PREFIXES.some((p) => path.startsWith(p));
}

function getOrCreateVisitorId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `vid-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    // localStorage utilgjengelig (privat modus o.l.)
    return `anon-${Date.now()}`;
  }
}

export async function trackPageView(path) {
  if (!BACKEND || isExcluded(path)) return;

  const payload = {
    path,
    session_id: getOrCreateVisitorId(),
    referrer: typeof document !== 'undefined' ? document.referrer || '' : '',
  };

  // Fire-and-forget. Aldri kast feil til kalleren.
  try {
    await fetch(`${BACKEND}/api/analytics/visit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch {
    // ignorer nettverksfeil
  }
}
